import React from 'react';
import { Beef, Droplets, Dog, Calendar, Leaf } from 'lucide-react';
import { type Product, KIBBLE_TYPE_LABELS, AGE_RANGE_LABELS } from '@/lib/mockData';

export default function ProductSpecs({ product }: { product: Product }) {
  const specs = [
    {
      key: 'spec-ingredient',
      icon: Beef,
      label: 'Ingrédient principal',
      value: product.mainIngredient,
      color: 'text-red-500',
    },
    {
      key: 'spec-protein',
      icon: Beef,
      label: 'Protéines',
      value: `${product.proteinPercent} %`,
      color: 'text-orange-500',
    },
    {
      key: 'spec-fat',
      icon: Droplets,
      label: 'Matières grasses',
      value: `${product.fatPercent} %`,
      color: 'text-amber-500',
    },
    {
      key: 'spec-type',
      icon: Leaf,
      label: 'Type',
      value: KIBBLE_TYPE_LABELS[product.kibbleType],
      color: 'text-green-600',
    },
    {
      key: 'spec-age',
      icon: Calendar,
      label: 'Tranche d\'âge',
      value: AGE_RANGE_LABELS[product.ageRange],
      color: 'text-blue-500',
    },
    {
      key: 'spec-size',
      icon: Dog,
      label: 'Taille recommandée',
      value: product.dogSizes.map((s) => s).join(', '),
      color: 'text-teal-600',
    },
  ];

  return (
    <div className="card p-4">
      <h4 className="font-display font-semibold text-sm text-gray-800 mb-3">Composition & profil</h4>
      <div className="space-y-2.5">
        {specs.map((spec) => (
          <div key={spec.key} className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <spec.icon size={13} className={spec.color} />
              <span className="text-xs text-gray-500">{spec.label}</span>
            </div>
            <span className="text-xs font-semibold text-gray-800 text-right">{spec.value}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-orange-50">
        <p className="text-xs text-gray-500 leading-relaxed">{product.description}</p>
      </div>
    </div>
  );
}